import { useState } from "react";
import {parseContent} from "./util"
import {audioBaseURL } from "../../constants"
import SafeAudio from "../audioplayer/safeAudio"


export default function OrderDragElementSmall({dragItemPosition, informAboutDragClick, content, finished, clicked}) {

    function dragStart(){
        console.log("clicked")
        console.log(dragItemPosition)
        if(clicked){
            informAboutDragClick(null)
        } else {
            informAboutDragClick(dragItemPosition)
        }
    }

    return (
        <div className={finished ? 'dnoItemContentFinished ' : clicked ? 'dnoItemContent dnoClicked' : 'dnoItemContent '} onClick={dragStart}>

            

{parseContent(content) &&
            <div className="dndItemContentWrapper ">
                <div className="" 
                    dangerouslySetInnerHTML={{__html: parseContent(content).contentBeforeAudio}}  
                />
                {parseContent(content).audioFileName 
                && <div>
                    <SafeAudio 
                        filename={parseContent(content).audioFileName}
                     />
                    {
                //    <audio controls src={audioBaseURL + parseContent(content).audioFileName}  ></audio>
                    }
                </div>}
                {parseContent(content).contentAfterAudio && 
                <div className="" 
                    dangerouslySetInnerHTML={{__html: parseContent(content).contentAfterAudio}}  
                /> }
            </div>
            }
        </div>
    )
}